import { buttonBaseCustomizations } from './ButtonBase';
import { buttonCustomizations } from './Button';
import { iconButtonCustomizations } from './IconButton';
import { toggleButtonCustomizations } from './ToggleButton';
import { checkboxCustomizations } from './Checkbox';
import { textInputCustomizations } from './TextInput';
import { labelCustomizations } from './Label';
import { sliderCustomizations } from './Slider';

/**
 * Merged customizations for every "input-like" MUI component in the
 * app. Consumed by the parent aggregator at Customizations/index.jsx.
 *
 * Add a new component here by:
 *   1. Creating <NewComponent>.jsx in this folder
 *   2. Exporting a `newComponentCustomizations` object of shape
 *      `{ MuiNewComponent: { styleOverrides|defaultProps|variants } }`
 *   3. Spreading it into the export below
 *
 * The snapshot test at inputs.test.jsx verifies every MUI component
 * key is present after the merge, so a missing import here fails CI.
 */
export const inputsCustomizations = {
  ...buttonBaseCustomizations,
  ...buttonCustomizations,
  ...iconButtonCustomizations,
  ...toggleButtonCustomizations,
  ...checkboxCustomizations,
  ...textInputCustomizations,
  ...labelCustomizations,
  ...sliderCustomizations,
};
